var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 36,
    viewBox: "0 0 26 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27.8 31.244 1.543-10.052h-9.646v-6.524c0-2.75 1.347-5.431 5.667-5.431h4.385V.679A53.5 53.5 0 0 0 21.965 0C14.022 0 8.83 4.815 8.83 13.53v7.661H0v10.053h8.83v24.3h10.867v-24.3Z",
    "data-name": "Icon awesome-facebook-f"
  })));
};
export default SvgFacebook;